module.exports = __webpack_public_path__ + "img/vip5.af9a75ea.png";